import { client } from './client';

export enum EmployeePermission {
  EditPlans = 1,
  BookDesks = 2,
  BookRooms = 7,
  BookParkingPlaces = 9,
  ViewBookedObjects = 3,
  ViewFeedbacks = 4,
  BookForOthers = 5,
  SystemAdmin = 6,
  QA = 8,
}

export interface ApiPermissions {
  employeeNumber: string;
  permissions: EmployeePermission[];
  spaces: number[];
  adminOfSpaces: number[];
}

export const getEmployeePermissions = async (): Promise<ApiPermissions> => {
  try {
    const response = await client.get<ApiPermissions>('/api/v2/permissions');

    return response.data;
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};

export interface EmployeePermissionFull {
  permissionId: EmployeePermission;
  enabled: boolean;
  isEditable: boolean;
}

export interface EmployeePermissionsFull {
  employeeNumber: string;
  permissions: EmployeePermissionFull[];
}

export const readEmployeePermissions = async (
  employeeNumber: string,
): Promise<EmployeePermissionsFull> => {
  try {
    const response = await client.get<EmployeePermissionsFull>(
      `/api/v2/permissions/edit/${employeeNumber}`,
    );

    return response.data;
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};

export interface UpdateEmployeePermissionsParams {
  employeeNumber: string;
  permissions: EmployeePermission[];
}

export const updateEmployeePermissions = async (
  params: UpdateEmployeePermissionsParams,
): Promise<void> => {
  try {
    await client.put('/api/v2/permissions/edit', params);
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};
